import { useMultiplePayment } from '../../../../hooks/sale/useMultiplePayment';
import { Wallet, DollarSign, CheckCircle2, AlertCircle } from 'lucide-react';

const PaymentSummaryTotals = () => {
  const { totalToPay, totalEntered, pendingAmount } = useMultiplePayment();

  const format = (value?: number) =>
    typeof value === 'number' ? value.toFixed(2) : '0.00';

  const isPending = Number(format(pendingAmount)) > 0;

  return (
    <div className="w-full px-1 py-2">
      
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">

        {/* 🧾 Título */}
        <div className="flex items-center gap-2">
          <Wallet className="h-5 w-5 text-primary" />
          <span className="font-medium text-black dark:text-white">
            Resumen de Pago
          </span>
        </div>

        {/* 📊 KPIs */}
        <div className="flex flex-wrap items-center gap-3 sm:gap-6 text-sm">

          {/* Total */}
          <div className="flex items-center gap-2">
            <DollarSign className="h-4 w-4 text-slate-500" />
            <span className="text-slate-500">Total:</span>
            <span className="font-semibold text-black dark:text-white">
              ${format(totalToPay)}
            </span>
          </div>

          {/* Ingresado */}
          <div className="flex items-center gap-2">
            <CheckCircle2 className="h-4 w-4 text-green-600" />
            <span className="text-slate-500">Ingresado:</span>
            <span className="font-medium text-green-600">
              ${format(totalEntered)}
            </span>
          </div>

          {/* Pendiente */}
          <div className="flex items-center gap-2">
            <AlertCircle
              className={`h-4 w-4 ${
                isPending ? 'text-red' : 'text-green-600'
              }`}
            />
            <span className="text-slate-500">Pendiente:</span>
            <span
              className={`font-semibold ${
                isPending ? 'text-red' : 'text-green-600'
              }`}
            >
              ${format(pendingAmount)}
            </span>
          </div>

        </div>
      </div>
    </div>
  );
};

export default PaymentSummaryTotals;